import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

export const CLIENT_LOGOS = [
    `${PUBLIC_IMG_URL}/logos/mubadala-logo.webp`,
    `${PUBLIC_IMG_URL}/logos/500-global-logo.webp`,
    `${PUBLIC_IMG_URL}/logos/aramco-logo.png`,
    `${PUBLIC_IMG_URL}/logos/global-ventures-logo.png`,
    `${PUBLIC_IMG_URL}/logos/svc-logo.webp`,
    `${PUBLIC_IMG_URL}/logos/mcit-logo.webp`
]

export const NEWS_REFERENCES_LOGOS = [
    { name: "AlArabia", logo: "/logos/alarabiya.avif", fallbackLogo: "/logos/alarabiya.png" },
    { name: "Gulf Business", logo: "/logos/gulf_business.avif" , fallbackLogo: "/logos/gulf_business.png" },
    { name: "Financial Times", logo: "/logos/financial-times.avif" , fallbackLogo: "/logos/financial-times.webp" },
    { name: "Bloomberg", logo: "/logos/bloomberg.avif" , fallbackLogo: "/logos/bloomberg.png" },
    { name: "CNN", logo: "/logos/cnn.avif" , fallbackLogo: "/logos/cnn.png" },
    { name: "Entrepreneur", logo: "/logos/entrepreneur.avif" , fallbackLogo: "/logos/entrepreneur.png" },
    { name: "Crunchbase News", logo: "/logos/cb_news.avif" , fallbackLogo: "/logos/cb_news.png" },
    { name: "Khaleej Times", logo: "/logos/khaleej_times.avif" , fallbackLogo: "/logos/khaleej_times.png" },
    { name: "The National", logo: "/logos/the_national.avif" , fallbackLogo: "/logos/the_national.png" },
    { name: "Wamda", logo: "/logos/wamda.avif" , fallbackLogo: "/logos/wamda.png" },
    { name: "World Economic Forum", logo: "/logos/world_economic_forum.avif", fallbackLogo: "/logos/world_economic_forum.png" },
    { name: "Arab News", logo: "/logos/arab_news.avif" , fallbackLogo: "/logos/arab_news.webp" },
    { name: "Tech Crunch", logo: "/logos/tech_crunch.avif" , fallbackLogo: "/logos/tech_crunch.png" },
    { name: "Tech In Asia", logo: "/logos/tech_in_asia.avif" , fallbackLogo: "/logos/tech_in_asia.webp" },
    { name: "The Wall Street Journal", logo: "/logos/the_wsj.avif" , fallbackLogo: "/logos/the_wsj.png" },
];
